var E_NOSCROLL = new Error('Element already at target scroll position')
var E_CANCELLED = new Error('Scroll cancelled')
var min = Math.min
var ms = Date.now

module.exports = {
  scrollY
}

function scrollY(to, opts, cb) {
  opts = opts || {}

  if (typeof opts == 'function') {
    cb = opts
    opts = {}
  }
  if (typeof cb != 'function') cb = noop

  var start = ms()
  var from = window.scrollY
  var ease = opts.ease || inOutSine
  var duration = !isNaN(opts.duration) ? +opts.duration : 350
  var cancelled = false

  // eslint-disable-next-line no-sequences
  return from === to ? cb(E_NOSCROLL, window.scrollY) : requestAnimationFrame(animate), cancel

  function cancel() {
    cancelled = true
  }

  function animate(timestamp) {
    if (cancelled) return cb(E_CANCELLED, window.scrollY)

    var now = ms()
    var time = min(1, (now - start) / duration)
    var eased = ease(time)
    window.scrollTo(0, eased * (to - from) + from)
    time < 1
      ? requestAnimationFrame(animate)
      : requestAnimationFrame(function () {
          cb(null, window.scrollY)
        })
  }
}

function inOutSine(n) {
  return 0.5 * (1 - Math.cos(Math.PI * n))
}

function noop() {}
